<template>
  <div class="serviceSelect">
    <div class="checkDiv" v-if="cityList.length > 0">
      <span>市级：</span>
      <ul>
        <li
          :class="{ service_isClick: activeIndex === item.CODE }"
          v-for="item in cityList"
          :key="item.CODE"
          @click="clickRegion(item)"
        >
          天门市
        </li>
      </ul>
    </div>
    <div class="checkDiv" v-if="townshipList.length > 0">
      <span>乡/镇级：</span>
      <ul>
        <li
          :class="{ service_isClick: activeIndex === item.CODE }"
          v-for="item in townshipList"
          :key="item.CODE"
          @click="clickRegion(item)"
        >
          {{ item.NAME }}
        </li>
      </ul>
    </div>
    <div class="checkDiv" v-if="villageList.length > 0">
      <span>村/社区级：</span>
      <ul>
        <li
          :class="{ service_isClick: activeIndex === item.CODE }"
          v-for="item in villageList"
          :key="item.CODE"
          @click="clickRegion(item)"
        >
          {{ item.NAME }}
        </li>
      </ul>
    </div>
    <div class="checkDiv position">
      <span>所在位置：</span>
      <p>
        天门市
        <span v-if="activeTownship">&gt; {{ activeTownship }}</span>
        <span v-if="activeVillage">&gt; {{ activeVillage }}</span>
      </p>
    </div>
  </div>
</template>

<script>
import { getRegionListApi } from '@/api/api'
export default {
  name: 'Server',
  data() {
    return {
      // 市
      cityList: [
        {
          CODE: '429006000000',
          PARENT_CODE: '420000000000',
          GRADE: '3',
          SHORT_CODE: '429006',
          NAME: '天门市'
        }
      ],
      // 乡/镇
      townshipList: [],
      // 村/社区
      villageList: [],
      // 当前高亮选项
      activeIndex: '429006000000',
      // 当前所在位置
      activeTownship: '',
      activeVillage: ''
    }
  },
  async mounted() {
    await this.initRegionList()
  },
  methods: {
    // 根据父级code获取子级名称
    async getRegionList(parentCode) {
      const res = await getRegionListApi({ parent_code: parentCode })
      return res.data
    },
    // 初始化地区列表
    async initRegionList() {
      this.townshipList = await this.getRegionList('429006000000')
      // this.activeTownship = this.townshipList[0].NAME
      // this.villageList = await this.getRegionList(this.townshipList[0].CODE)
    },
    // 点击地区
    async clickRegion(region) {
      this.activeIndex = region.CODE
      // 点击的是市
      if (region.GRADE === '3') {
        this.townshipList = await this.getRegionList(region.CODE)
        this.villageList = ''
        this.activeTownship = ''
        this.activeVillage = ''

        this.$emit('getRegionInfo', '3', region.CODE)
        this.$emit('drawServiceList')
      }

      // 点击的是乡镇
      if (region.GRADE === '5') {
        this.villageList = await this.getRegionList(region.CODE)
        this.activeTownship = region.NAME
        this.activeVillage = ''

        this.$emit('getRegionInfo', '5', region.CODE)
        this.$emit('drawServiceList')
      }
      // 点击的是村/社区
      if (region.GRADE === '6') {
        this.activeVillage = region.NAME

        this.$emit('getRegionInfo', '6', region.CODE)
        this.$emit('drawServiceList')
      }
    }
  }
}
</script>

<style lang="less">
.serviceSelect {
  position: relative;
  background-color: #f7f7f7;
  padding: 12px 6px;
  border: 1px solid #e0e0e0;
}
.checkDiv {
  margin-bottom: 14px;
  font-size: 14px;
  & > span {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    min-width: 80px;
    text-align: right;
    vertical-align: middle;
  }
  & > ul {
    display: inline-block;
    vertical-align: top;
    max-width: 720px;
    & > li {
      padding: 0 6px;
      cursor: pointer;
      margin-right: 10px;
      height: 30px;
      line-height: 30px;
      display: inline-block;
      vertical-align: middle;
      color: #878787;
      font-size: 14px;
    }
    .service_isClick {
      background: #3c93d8;
      border-radius: 5px;
      color: #fff;
    }
  }
}
.position {
  & > span {
    display: inline-block;
    height: 30px;
    line-height: 30px;
    min-width: 85px;
    text-align: right;
    font-size: 14px;
    vertical-align: middle;
  }
  p {
    display: inline-block;
    vertical-align: middle;
    font-size: 13px;
    line-height: 30px;
    font-weight: 600;
    height: 30px;
    color: #fd5353;
    & > span {
      margin: 0 3px;
    }
  }
}
</style>
